// @ts-nocheck

import { mapValues, pickBy } from 'lodash';

import { BasketItemStatuses, BasketModes } from '../../../types/basket';

const buildItems = ({
  oddId,
  matchId,
  betId,
  sportId,
  banker,
  sortBy,
  betbuilder,
  value,
  validatedValue,
  selectionItems,
}) => ({
  oddId,
  matchId,
  betId,
  sportId,
  banker,
  sortBy,
  value: validatedValue || value,
  selectionItems,
  betbuilder,
});

/**
 * Return the nextState corresponding to the BASKET_SET_SELECTION action
 *
 * @static
 * @param  {Object} state  The actual state
 * @return {Object}        Return the new state.
 */
const basketSetSelection = (state) => {
  const { items, status, mode } = state;
  let nextItems = {};

  if (mode === BasketModes.SIMPLE) {
    nextItems = mapValues(
      pickBy(items, (obj) => [BasketItemStatuses.VALIDATED, BasketItemStatuses.REJECTED].includes(obj.status)),
      buildItems,
    );
  } else if ([BasketItemStatuses.VALIDATED, BasketItemStatuses.REJECTED].includes(status)) {
    nextItems = mapValues(items, buildItems);
  }

  return {
    ...state,
    itemsMemoizedForSelection: nextItems,
  };
};

export default basketSetSelection;
